import React, { useEffect, useState } from "react";
import { useCurrentEditor } from "@tiptap/react";
import {
  Highlighter,
  ImageSquare,
  LineVertical,
  ListBullets,
  ListNumbers,
  NotEquals,
  Paperclip,
  TextAlignCenter,
  TextAlignJustify,
  TextAlignLeft,
  TextAlignRight,
  TextB,
  TextItalic,
  TextStrikethrough,
  TextH,
  TextHOne,
  TextHTwo,
  TextHThree,
  TextHFour,
  TextHFive,
  TextHSix,
} from "@phosphor-icons/react";
import { Popover, Typography } from "@mui/material";
import { fileservice, fileSizeCofig } from "../../../../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import { connect } from "react-redux";
import { setAttachment } from "../../../../../Redux/Actions/actions";
import { toast } from "react-toastify";
import { toaststyle } from "../../../../../Utils/toaststyle";

const mapStateToProps = (state) => {
  return {
    attachment: state.email.attachment,
  };
};


const MenuBar = (props) => {
  const { setAttachment, attachment, selectedtemplate, setselectedtemplate } =
    props;
  const loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
  const selectedEmail = JSON.parse(localStorage.getItem("client"));

  const { editor } = useCurrentEditor();
  const [imageQueue, setImageQueue] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openAlign, setOpenAlign] = React.useState(null);
  const [openHeading, setOpenHeading] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickAlign = (event) => {
    setOpenAlign(event.currentTarget);
  };
  const handleCloseAlign = () => {
    setOpenAlign(null);
  };

  const handleClickHeading = (event) => {
    setOpenHeading(event.currentTarget);
  };
  const handleCloseHeading = () => {
    setOpenHeading(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const openAlignment = Boolean(openAlign);
  const idAlign = openAlignment ? "simple-popover" : undefined;

  const openHeadingtag = Boolean(openHeading);
  const idHeading = openHeadingtag ? "simple-popover" : undefined;

  const fileUpload = async (event) => {
    event.preventDefault();
    const file = event.target.files[0];

    if (!file) return toast.error("Something Went Wrong", toaststyle);
    if (file.size >= fileSizeCofig) {
      event.target.value = "";
      toast.error("File Too Large", toaststyle);
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", file.name);
    formData.append("fileType", file.type);
    formData.append("sentBy", "Customer");
    formData.append("userID", loggedInAgent.agent_id);
    formData.append("clientApp", "InapiWebchat");
    formData.append("channel", "email");
    formData.append("sessionId", selectedEmail.chat_session_id);

    await axios
      .post(fileservice + "/fileServer/uploadMedia", formData, {
        headers: {
          "content-type": "multipart/form-data",
          tenantId: "123456",
        },
      })
      .then((res) => {
        console.log("fileUpload", res);
        if (res.data.status) {
          const fileType = file.type;
          if (allowedFormats.includes(fileType)) {
            const finalFile = {
              filename: file.name,
              fileType: res.data.data.extension,
              datetime: file.lastModifiedDate.toLocaleString("en-IN"),
              filesize: file.size,
              attachmentUrl: res.data.data.signedUrl,
            };
            setAttachment([...attachment, finalFile]);
            toast.success(res.data.message, toaststyle);
            event.target.value = "";
          }
        } else {
          toast.error(res.data.message, toaststyle);
          event.target.value = "";
        }
      })
      .catch((err) => {
        event.target.value = "";
        console.log("fileUpload", err);
        toast.error(err.response.data.message, toaststyle);
      });
  };

  const handleImageUpload = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.multiple = true;
    input.onchange = (event) => {
      const files = Array.from(event.target.files);
      setImageQueue(files);
    };
    input.click();
  };

  useEffect(() => {
    const insertNextImage = () => {
      if (imageQueue.length > 0) {
        const file = imageQueue[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          const imageUrl = e.target.result;
          editor
            .chain()
            .focus()
            .setImage({ src: imageUrl })
            .insertContent(`<br/>`)
            .run();
          setImageQueue((prevQueue) => prevQueue.slice(1));
        };
        reader.readAsDataURL(file);
      }
    };

    insertNextImage();
  }, [imageQueue, editor]);

  useEffect(() => {
    if (editor) {
      editor.chain().focus().run();
    }
  }, [editor]);

  useEffect(() => {
    if (selectedtemplate) {
      editor
        .chain()
        .focus()
        .insertContent(`${selectedtemplate} <br><br>`)
        .run();
      setselectedtemplate();
    }
  }, [selectedtemplate, editor]);

  return (
    <>
      <div
        className="Editor_toolbar"
        // style={{
        //   boxShadow:
        //     "rgb(207, 209, 214) 0px 8px 8px, rgb(200 200 200) 0px 0px 6px",
        // }}
      >
        <button
          onClick={() => editor.chain().focus().toggleBold().run()}
          disabled={!editor.can().chain().focus().toggleBold().run()}
          className={`editor_button ${
            editor.isActive("bold") ? "is-active" : ""
          }`}
        >
          <TextB size={18} weight="bold" />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleItalic().run()}
          disabled={!editor.can().chain().focus().toggleItalic().run()}
          className={`editor_button ${
            editor.isActive("italic") ? "is-active" : ""
          }`}
        >
          <TextItalic size={18} weight="bold" />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleStrike().run()}
          disabled={!editor.can().chain().focus().toggleStrike().run()}
          className={`editor_button ${
            editor.isActive("strike") ? "is-active" : ""
          }`}
        >
          <TextStrikethrough size={18} weight="bold" />
        </button>
        <button
          className="editor_button"
          aria-describedby={id}
          onClick={handleClickHeading}
        >
          <TextH size={18} weight="bold" />
        </button>
        <button
          className="editor_button"
          aria-describedby={id}
          onClick={handleClickAlign}
        >
          <TextAlignJustify size={18} weight="bold" />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleBulletList().run()}
          className={`editor_button ${
            editor.isActive("bulletList") ? "is-active" : ""
          }`}
        >
          <ListBullets size={18} weight="bold" />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
          className={`editor_button ${
            editor.isActive("orderedList") ? "is-active" : ""
          }`}
        >
          <ListNumbers size={18} weight="bold" />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleBlockquote().run()}
          className={`editor_button ${
            editor.isActive("blockquote") ? "is-active" : ""
          }`}
        >
          <LineVertical size={18} weight="bold" />
        </button>
        <button
          onClick={() => editor.chain().focus().setColor("#ffd119").run()}
          className={`editor_button ${
            editor.isActive("textStyle", { color: "#958DF1" })
              ? "is-active"
              : ""
          }`}
        >
          <Highlighter size={18} weight="bold" />
        </button>
        <button
          onClick={handleImageUpload}
          className={`editor_button ${
            editor.isActive("image", { color: "#958DF1" }) ? "is-active" : ""
          }`}
        >
          <ImageSquare size={18} weight="bold" />
        </button>

        <label htmlFor="file-upload" className="editor_button">
          <Paperclip size={18} weight="bold" />
        </label>
        <input
          id="file-upload"
          type="file"
          onChange={fileUpload}
          style={{ display: "none" }}
        />
      </div>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Typography sx={{ p: 1 }}>
          <button
            className={`editor_button ${
              editor.isActive("insertTable", { color: "#958DF1" })
                ? "is-active"
                : ""
            }`}
            onClick={() =>
              editor
                .chain()
                .focus()
                .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
                .run()
            }
          >
            insertTable
          </button>
          <button
            className={`editor_button ${
              editor.isActive("addColumnBefore", { color: "#958DF1" })
                ? "is-active"
                : ""
            }`}
            onClick={() => editor.chain().focus().addColumnBefore().run()}
          >
            addColumnBefore
          </button>
          <button
            className={`editor_button ${
              editor.isActive("addColumnAfter", { color: "#958DF1" })
                ? "is-active"
                : ""
            }`}
            onClick={() => editor.chain().focus().addColumnAfter().run()}
          >
            addColumnAfter
          </button>
          <button
            className={`editor_button ${
              editor.isActive("deleteColumn", { color: "#958DF1" })
                ? "is-active"
                : ""
            }`}
            onClick={() => editor.chain().focus().deleteColumn().run()}
          >
            deleteColumn
          </button>
          <button
            className={`editor_button ${
              editor.isActive("addRowBefore", { color: "#958DF1" })
                ? "is-active"
                : ""
            }`}
            onClick={() => editor.chain().focus().addRowBefore().run()}
          >
            addRowBefore
          </button>
          <button
            className={`editor_button ${
              editor.isActive("addRowAfter", { color: "#958DF1" })
                ? "is-active"
                : ""
            }`}
            onClick={() => editor.chain().focus().addRowAfter().run()}
          >
            addRowAfter
          </button>
          <button
            className={`editor_button ${
              editor.isActive("deleteRow", { color: "#958DF1" })
                ? "is-active"
                : ""
            }`}
            onClick={() => editor.chain().focus().deleteRow().run()}
          >
            deleteRow
          </button>
          <button
            className={`editor_button ${
              editor.isActive("deleteTable", { color: "#958DF1" })
                ? "is-active"
                : ""
            }`}
            onClick={() => editor.chain().focus().deleteTable().run()}
          >
            deleteTable
          </button>
          <button
            className={`editor_button ${
              editor.isActive("toggleHeaderColumn", { color: "#958DF1" })
                ? "is-active"
                : ""
            }`}
            onClick={() => editor.chain().focus().toggleHeaderColumn().run()}
          >
            toggleHeaderColumn
          </button>
          <button
            className={`editor_button ${
              editor.isActive("toggleHeaderRow", { color: "#958DF1" })
                ? "is-active"
                : ""
            }`}
            onClick={() => editor.chain().focus().toggleHeaderRow().run()}
          >
            toggleHeaderRow
          </button>
          <button
            className={`editor_button ${
              editor.isActive("toggleHeaderCell", { color: "#958DF1" })
                ? "is-active"
                : ""
            }`}
            onClick={() => editor.chain().focus().toggleHeaderCell().run()}
          >
            toggleHeaderCell
          </button>
        </Typography>
      </Popover>

      <Popover
        id={idAlign}
        open={openAlignment}
        anchorEl={openAlign}
        onClose={handleCloseAlign}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Typography sx={{ p: 1 }}>
          <button
            onClick={() => editor.chain().focus().setTextAlign("left").run()}
            className={`editor_button ${
              editor.isActive({ textAlign: "left" }) ? "is-active" : ""
            }`}
          >
            <TextAlignLeft size={18} />
          </button>
          <button
            onClick={() => editor.chain().focus().setTextAlign("center").run()}
            className={`editor_button ${
              editor.isActive({ textAlign: "center" }) ? "is-active" : ""
            }`}
          >
            <TextAlignCenter size={18} />
          </button>
          <button
            onClick={() => editor.chain().focus().setTextAlign("right").run()}
            className={`editor_button ${
              editor.isActive({ textAlign: "right" }) ? "is-active" : ""
            }`}
          >
            <TextAlignRight size={18} />
          </button>
          <button
            onClick={() => editor.chain().focus().setTextAlign("justify").run()}
            className={`editor_button ${
              editor.isActive({ textAlign: "justify" }) ? "is-active" : ""
            }`}
          >
            <TextAlignJustify size={18} />
          </button>
          <button
            onClick={() => editor.chain().focus().unsetTextAlign().run()}
            className="editor_button"
          >
            <NotEquals size={18} />
          </button>
        </Typography>
      </Popover>

      <Popover
        id={idHeading}
        open={openHeadingtag}
        anchorEl={openHeading}
        onClose={handleCloseHeading}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Typography sx={{ p: 1 }}>
          <button
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 1 }).run()
            }
            className={`editor_button_heading ${
              editor.isActive("heading", { level: 1 }) ? "is-active" : ""
            }`}
          >
            <TextHOne size={17} />
          </button>
          <button
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 2 }).run()
            }
            className={`editor_button_heading ${
              editor.isActive("heading", { level: 2 }) ? "is-active" : ""
            }`}
          >
            <TextHTwo size={17} />
          </button>
          <button
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 3 }).run()
            }
            className={`editor_button_heading ${
              editor.isActive("heading", { level: 3 }) ? "is-active" : ""
            }`}
          >
            <TextHThree size={17} />
          </button>
          <button
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 4 }).run()
            }
            className={`editor_button_heading ${
              editor.isActive("heading", { level: 4 }) ? "is-active" : ""
            }`}
          >
            <TextHFour size={17} />
          </button>
          <button
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 5 }).run()
            }
            className={`editor_button_heading ${
              editor.isActive("heading", { level: 5 }) ? "is-active" : ""
            }`}
          >
            <TextHFive size={17} />
          </button>
          <button
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 6 }).run()
            }
            className={`editor_button_heading ${
              editor.isActive("heading", { level: 6 }) ? "is-active" : ""
            }`}
          >
            <TextHSix size={17} />
          </button>
        </Typography>
      </Popover>
    </>
  );
};

export default connect(mapStateToProps, {
  setAttachment,
})(MenuBar);
